import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody } from 'reactstrap';
import './styles.css';

import { ReactComponent as WelcomeStep1 } from './welcome-step-1.svg';
import { ReactComponent as WelcomeStep2 } from './welcome-step-2.svg';
import { ReactComponent as WelcomeStep3 } from './welcome-step-3.svg';
import { ReactComponent as WelcomeStep4 } from './welcome-step-4.svg';
import { ReactComponent as GoIcon } from './go-icon.svg';
import { useToggle } from 'react-use';

const WelcomeModal = ({ openState = true }) => {
    const [isOpen, toggleOpenStatus] = useToggle(false);

    useEffect(() => {
        toggleOpenStatus(openState);
    }, [openState]);

    return (
        <Modal isOpen={isOpen} className="welcome-modal">
            <ModalBody className="welcome-modal__container">
                <h1 className="welcome-modal__title mb-4">Welcome to your idea testing ground!</h1>
                <div className="welcome-modal__description mb-5">
                    We’re thrilled to have you with us! This is a platform for you to filter your
                    ideas by getting them in front of industry professionals, colleagues and
                    friends. If you feel you’ve got some advice please share it. Go forth and
                    create!
                </div>
                <div className="d-flex justify-content-center">
                    <div className="d-flex">
                        <WelcomeStep1 />
                        <div className="welcome-modal__delimiter" />
                        <WelcomeStep2 />
                        <div className="welcome-modal__delimiter" />
                        <WelcomeStep3 />
                        <div className="welcome-modal__delimiter" />
                        <WelcomeStep4 />
                    </div>
                </div>
                <div className="d-flex">
                    <span className="welcome-modal__step-description mx-4">Post a question.</span>
                    <span className="welcome-modal__step-description mx-4">
                        Get feedback from the community.
                    </span>
                    <span className="welcome-modal__step-description mx-4">
                        Donate to the best responses and vice versa!
                    </span>
                    <span className="welcome-modal__step-description mx-4">
                        Proceed with winning ideas.
                    </span>
                </div>
            </ModalBody>
            <div className="welcome-modal__footer d-flex justify-content-center py-3">
                <button
                    type="button"
                    className="align-items-center d-flex justify-content-center welcome-modal__footer-button"
                    onClick={toggleOpenStatus}
                >
                    Create your first post
                    <div className="ml-1">
                        <GoIcon />
                    </div>
                </button>
            </div>
        </Modal>
    );
};

WelcomeModal.propTypes = {
    openState: PropTypes.bool.isRequired,
};

export default React.memo(WelcomeModal);
